import avatar1 from '../../assets/images/user/1.jpg';
import avatar2 from '../../assets/images/user/2.png';
import avatar3 from '../../assets/images/dashboard/admins.png';

export const CHAT_DROPDOWN = [
  {
    image: avatar1,
    title: 'Ain Chavez',
    subTitle: 'Do you want to go see movie?',
    time: 1 * 1000 * 60,
    online: true,
  },
  {
    image: avatar2,
    title: 'Kori Thomas',
    subTitle: 'What`s the project report update?',
    time: 3 * 1000 * 60,
    online: true,
  },
  {
    image: avatar3,
    title: 'Ain Chavez',
    subTitle: 'Thank you for rating us.',
    time: 9 * 1000 * 60,
    online: false,
  },
];
